import React from 'react';
import noImageHotel from '../../../images/noImageHotel.svg';
import * as S from './styles';
export type ImageMosaicProps = {
  images: string[];
  size?: 'sm' | 'lg';
  /**
   * Ex: '300px'
   */
  customHeight?: string;
  onClick?: (index: number) => void;
};
const ImageMosaic: React.FC<ImageMosaicProps> = ({
  images,
  size,
  onClick,
  customHeight
}) => {
  const [noImageIndexes, setNoImageIndexes] = React.useState<number[]>([]);
  const onImageError = (index: number, e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = noImageHotel;
    setNoImageIndexes(prev => [...prev, index]);
  };
  const ensureMinImages = (images: string[], minLength: number, fallbackImage: string) => {
    const filledImages = [...images];
    while (filledImages.length < minLength) {
      filledImages.push(fallbackImage);
    }
    return filledImages;
  };
  const limitedImages = React.useMemo(() => {
    const minImages = size === 'lg' ? 4 : 5;
    ensureMinImages;
    return ensureMinImages(images, minImages, noImageHotel).slice(0, minImages);
  }, [images, size]);
  return <S.MosaiContainer size={size} customHeight={customHeight}>
      {limitedImages.map((img, idx) => <S.MosaicDiv key={idx} index={idx} size={size}>
          <S.Image src={img} alt={`imagem-${idx}`} onError={e => onImageError(idx, e)} isFallback={noImageIndexes.includes(idx) || limitedImages[idx] === noImageHotel} onClick={() => onClick(idx)} />
        </S.MosaicDiv>)}
    </S.MosaiContainer>;
};
export default ImageMosaic;